/* components/ui/Toast.jsx — визуальный элемент тоста (тон = из _enums).
   Рендерится стопкой провайдером ToastProvider.
   Глиф берём из единого словаря тон→глиф (Badge.TONE_GLYPH) через мост
   семантический→badge-токен (enums.TONE_TOKEN) — Badge и Toast не дрейфуют (P2-04). */

import { Icon } from './Icon.jsx';
import { TONE_GLYPH } from './Badge.jsx';
import { enums as E } from '../../lib/enums.js';

  // Алиасы устаревших badge-токенов → семантический тон (защита от вызовов toast('ok'/'bad'), P1-14).
  const TONE_ALIAS = { ok: 'success', bad: 'danger', warn: 'warning', neutral: 'muted', info: 'accent' };

  function Toast({ message, tone = 'muted', onDismiss }) {
    const sem = TONE_ALIAS[tone] || tone;                 // нормализуем к семантическому токену (success/danger/…)
    const glyph = TONE_GLYPH[E.TONE_TOKEN[sem]] || 'info'; // единый источник глифов (через TONE_TOKEN)
    return (
      <div className={`toast toast--${sem}`} role="status">
        <span className="toast__glyph"><Icon name={glyph} size={16} /></span>
        <span className="toast__msg grow">{message}</span>
        <button className="toast__close" onClick={onDismiss} aria-label="Закрыть">
          <Icon name="close" size={14} />
        </button>
      </div>
    );
  }

export { Toast };
